import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Rider\PhotoTagController::store
* @see app/Http/Controllers/Rider/PhotoTagController.php:38
* @route '/profil/fotky/{photo}/oznacit'
*/
export const store = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/profil/fotky/{photo}/oznacit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::store
* @see app/Http/Controllers/Rider/PhotoTagController.php:38
* @route '/profil/fotky/{photo}/oznacit'
*/
store.url = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { photo: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { photo: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            photo: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
    }

    return store.definition.url
            .replace('{photo}', parsedArgs.photo.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::store
* @see app/Http/Controllers/Rider/PhotoTagController.php:38
* @route '/profil/fotky/{photo}/oznacit'
*/
store.post = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::store
* @see app/Http/Controllers/Rider/PhotoTagController.php:38
* @route '/profil/fotky/{photo}/oznacit'
*/
const storeForm = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::store
* @see app/Http/Controllers/Rider/PhotoTagController.php:38
* @route '/profil/fotky/{photo}/oznacit'
*/
storeForm.post = (args: { photo: number | { id: number } } | [photo: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::destroy
* @see app/Http/Controllers/Rider/PhotoTagController.php:79
* @route '/profil/fotky/{photo}/oznacit/{vehicle}'
*/
export const destroy = (args: { photo: number | { id: number }, vehicle: number | { id: number } } | [photo: number | { id: number }, vehicle: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/profil/fotky/{photo}/oznacit/{vehicle}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::destroy
* @see app/Http/Controllers/Rider/PhotoTagController.php:79
* @route '/profil/fotky/{photo}/oznacit/{vehicle}'
*/
destroy.url = (args: { photo: number | { id: number }, vehicle: number | { id: number } } | [photo: number | { id: number }, vehicle: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            photo: args[0],
            vehicle: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        photo: typeof args.photo === 'object'
        ? args.photo.id
        : args.photo,
        vehicle: typeof args.vehicle === 'object'
        ? args.vehicle.id
        : args.vehicle,
    }

    return destroy.definition.url
            .replace('{photo}', parsedArgs.photo.toString())
            .replace('{vehicle}', parsedArgs.vehicle.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::destroy
* @see app/Http/Controllers/Rider/PhotoTagController.php:79
* @route '/profil/fotky/{photo}/oznacit/{vehicle}'
*/
destroy.delete = (args: { photo: number | { id: number }, vehicle: number | { id: number } } | [photo: number | { id: number }, vehicle: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::destroy
* @see app/Http/Controllers/Rider/PhotoTagController.php:79
* @route '/profil/fotky/{photo}/oznacit/{vehicle}'
*/
const destroyForm = (args: { photo: number | { id: number }, vehicle: number | { id: number } } | [photo: number | { id: number }, vehicle: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Rider\PhotoTagController::destroy
* @see app/Http/Controllers/Rider/PhotoTagController.php:79
* @route '/profil/fotky/{photo}/oznacit/{vehicle}'
*/
destroyForm.delete = (args: { photo: number | { id: number }, vehicle: number | { id: number } } | [photo: number | { id: number }, vehicle: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const tag = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default tag